
"use client";
import styled from "styled-components"; 
import { useEffect, useState, useRef } from "react";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext"; 
import { useMyContext } from '@/app/utils/MyContext';
import CalendarSvgIcon from "@/app/ui/Common/SvgComponent/CalendarSvgIcon";
import CalendarPopper from "./calendarPopper";
import UpComingRaceCards from "./UpComingRaceCards";
import {getUpcomingRaceCMS, getUpcomingRaceQIDS} from "@/app/utils/request/requestList";
import {  toDayJS, toDate, formattedDate, compareDate, dateFormat } from "@/app/utils/DayJS";
import "@/app/style/upcomingRaces.scss"; 
import { setRouting, setRacesDetailLoading, adobeData, generateAdobeDataRaceNo} from "@/app/utils/Common";
import Tips from '@/app/ui/Common/Tips';
import Sticky from 'react-stickynode';

const UpcomingRaces = (props: any) => { 
    const { upComRaceData } = props;
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();  
    const [mtId, setmtId] = useState<string>("All");
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [meetingFilter, setmeetingFilter] = useState([] as any);
    const langCode = lang.langCode;
    useEffect(() => {
        const _meetingFilter_ALL = [
            {lable: t("all_races"), id: "All"}
        ] as any;
        const _meetingFilter = upComRaceData?._meetingFilter || [] as any;
        const _None = upComRaceData?._None;
        if (!_None) {
            _meetingFilter_ALL.concat(_meetingFilter);
            setmeetingFilter([..._meetingFilter_ALL, ..._meetingFilter]);

            const _curActiveId =  localStorage.getItem('upcoming_filterTab');
            const _isCur = upComRaceData?._upComingList?.find((i:any) => i?.id == _curActiveId);
            if (_curActiveId && _isCur) {
                setmtId(_curActiveId)
            } else {
                // after EOD/SOD, meeting data will change, default land All
                setmtId("All")
            }
        }

        console.log('UpcomingRaces---', _meetingFilter)
    }, [upComRaceData])

    console.log("UpcomingRaces ---myContextState", upComRaceData, myContextState)
    

    const onClickMeetingBar = (item: any) => {
        localStorage.setItem('upcoming_filterTab', item?.id);
        setmtId(item?.id)
        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: "racing/simulcast_Click_AnyPage_UpcomingRace-MeetingFilter",
            country: myContextState.selectedMeeting?.countryNameEn || '',
            buttonName: "racing/simulcast_Click_" + (item?.id == "All" ? "All Races" : item?.enLabel || item?.lable),
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });
    }

    const handleOutSideclick = (event: any) => {
        if (anchorEl && props.type == "pc") {
            const targetDiv = document.querySelector('.calendarPopper');
            const rect = targetDiv?.getBoundingClientRect() || {} as any;

            const isInside =
                event?.clientX >= rect?.left &&
                event?.clientX <= rect?.right &&
                event?.clientY >= rect?.top &&
                event?.clientY <= rect?.bottom;

            if (!isInside) {
                setAnchorEl(null)
            }
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleOutSideclick);
        return () => {
            document.removeEventListener('click', handleOutSideclick);
        }
    }, [anchorEl]);

    const handleCalendarClink = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: "racing/simulcast_Click_AnyPage_UpcomingRace-Calendar",
            country: myContextState.selectedMeeting?.countryNameEn || '',
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });
    };

    const handleCalendarClose = () => {
        setAnchorEl(null);
    }

    return props?.upComRaceData && !props?.upComRaceData?._None ? <>
        <div className="upComingRacesRaces">
            <div className="upComingHeader" > 
                <span>{t("upcoming_races")}</span>
                <p  onClick={(e) => {handleCalendarClink(e)}}> 
                    <CalendarSvgIcon /> 
                     {t("race_calendar")}
                </p>
            </div>
            <CalendarPopper type={props.type} anchorEl={anchorEl} meetings={props?.meetings} handleCalendarClose={handleCalendarClose}/>
        </div>
        {/* <div className="racesItem" style={{position: props?.clickTipOnly ? "relative" : "sticky"}} > */}
        <Sticky innerZ={150} enabled={!props?.clickTipOnly} top={0} innerClass="racesItem">
            <div >
                {
                    meetingFilter?.map((item: any, num: number) => 
                    <p className={mtId == item?.id ? "active" : ""} key={num} onClick={() => onClickMeetingBar(item)}>
                        {item?.lable}
                    </p>
                    )
                } 
            </div> 
            <UpComingRaceCards type={props.type} mtId={mtId} upComingList={upComRaceData?._upComingList}/>

            {props.showTips1 && (<Tips isPositionLeft={true} localStoragekey="tip1" message={t("mobile_dropdown_menu_tips1")} onDismiss={props.onTips1Dismiss}/>)}
        {/* </div> */}
        </Sticky>
        
    </> : null
}
export default UpcomingRaces